module.exports = __webpack_public_path__ + "static/Pharmille-01-1d6fa8278d8e73f63938bc513a34cdd3.mp4";